var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseMenuWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 91 612 612",
    style: {
      enableBackground: "new 0 91 612 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Error"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M420.5,309.8c-0.3-6.9-2.9-13.8-8.2-19.1c-5.3-5.3-12.2-7.9-19.1-8.2c-7.7-0.3-15.5,2.3-21.4,8.2L306,356.4 l-65.8-65.8c-5.9-5.9-13.7-8.5-21.4-8.2c-6.9,0.3-13.8,2.9-19.1,8.2c-5.3,5.3-7.9,12.2-8.2,19.1c-0.3,7.7,2.3,15.5,8.2,21.4 l65.8,65.8l-65.8,65.8c-5.9,5.9-8.5,13.7-8.2,21.4c0.3,6.9,2.9,13.8,8.2,19.1c5.3,5.3,12.2,7.9,19.1,8.2 c7.7,0.3,15.5-2.3,21.4-8.2l65.8-65.8l65.8,65.8c5.9,5.9,13.7,8.5,21.4,8.2c6.9-0.3,13.8-2.9,19.1-8.2c5.3-5.3,7.9-12.2,8.2-19.1 c0.3-7.7-2.3-15.5-8.2-21.4L346.6,397l65.8-65.8C418.2,325.3,420.8,317.5,420.5,309.8z M306,91C137,91,0,228,0,397 s137,306,306,306s306-137,306-306S475,91,306,91z M306,645.6C168.9,645.6,57.4,534.1,57.4,397S168.9,148.4,306,148.4 S554.6,259.9,554.6,397S443.1,645.6,306,645.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenuWhite);
export default __webpack_public_path__ + "static/media/close-menu_white.311a790cee5214efb6d4192f6b2327f0.svg";
export { ForwardRef as ReactComponent };